import { matchPath } from 'react-router-dom';

import WandSparklesSvg from '../global/SvgComponents/WandSparkles_svg';
import SparklesSvg from '../global/SvgComponents/Sparkles_svg';
import RecycleSvg from '../global/SvgComponents/Recycle_svg';
import MembershipSvg from '../global/SvgComponents/Membership_svg';
import WalletSvg from '../global/SvgComponents/Wallet_svg';
import UserCircleSvg from '../global/SvgComponents/UserCircle_svg';

import {
  ROUTE_SIGNUP,
  ROUTE_LOGIN,
  ROUTE_HOME,
  ROUTE_LOGOUT,
  ROUTE_SETTINGS,
  ROUTE_ADDRESSES,
  ROUTE_REDEEM,
  ROUTE_DASHBOARD,
  ROUTE_PROFILE,
  ROUTE_REGISTER,
  ROUTE_WALLET,
  ROUTE_TAKE_BACK_BAGS,
  ROUTE_TAKE_BACK_BAGS_DETAILS,
  ROUTE_MY_ACCOUNT,
  ROUTE_WEB_NOTIFICATIONS_INBOX,
  ROUTE_WEB_NOTIFICATIONS_INBOX_ACCOUNT,
  TYPE_SEARCH_PARAM,
  EMAIL_SEARCH_PARAM,
  ROUTE_REWARD,
  PROMO_ID_PARAM,
  ROUTE_REWARDS,
  WF_RETURN_URL_SEARCH_PARAM,
  CATEGORY_SEARCH_PARAM,
  ROUTE_TRANSACTIONS,
  ROUTE_OFFERS,
  SORT_SEARCH_PARAM,
  FILTER_SEARCH_PARAMS,
  ROUTE_REWARDS_OLD,
  ROUTE_DEALS,
  REGISTER_SIGNED_AT_PARAM,
  REGISTER_SIGN_PARAM,
  REGISTER_CODE_PARAM,
  REGISTER_DATA_PARAM,
  ROUTES_TREE,
  ROUTE_GIFT_CARDS,
  TAB_SEARCH_PARAM,
  ROUTE_DASHBOARD_REWARDS,
  REGISTER_FROM_CHECKOUT_PARAM,
  SUBSCRIPTION_FROM_CHECKOUT_PARAM,
  EMBED_LOGIN_BACKGROUND_SEARCH_PARAM,
  ROUTE_REWARDS_V2,
  ROUTE_DEAL_STORE_REWARD_ID,
  ROUTE_REWARDS_V2_STORE_REWARD_ID,
  ROUTE_DEAL_STORE_ID,
  ROUTE_REWARDS_V2_STORE_ID,
  ROUTE_REWARDS_V2_LIST,
  ROUTE_GIFT_CARDS_V2,
  ROUTE_OFFERS_V2,
  ROUTE_MEMBERSHIP_ADDRESSES,
  ROUTE_SUBSCRIPTION,
  ROUTE_UNLIMITED,
  ROUTE_TRASHIE_UNLIMITED,
  ROUTE_MEMBERSHIP,
  MEMBERSHIP_CONFIRM_PARAM,
  STRIPE_SETUP_INTENT_CLIENT_SECRET_PARAM,
  STRIPE_CHECKOUT_SESSION_ID_PARAM,
  ROUTE_ONE_TIME_ORDER,
  ROUTE_SHARE,
} from '../config/routes';

const isLoginPath = (path) => path === ROUTE_LOGIN;

const isSignupPath = (path) => path === ROUTE_SIGNUP;

const isTrackedPath = (path) => !isLoginPath(path) && !isSignupPath(path);

const isRedeemPath = (path) => path === ROUTE_REDEEM || path === ROUTE_REGISTER;

const isSharePath = (path) => path.startsWith(ROUTE_SHARE);

const isContainerPath = (path) => (
  [
    ROUTE_HOME,
    ROUTE_REDEEM,
    ROUTE_REGISTER,
    ROUTE_SUBSCRIPTION,
    ROUTE_UNLIMITED,
    ROUTE_TRASHIE_UNLIMITED,
    ROUTE_ONE_TIME_ORDER,
  ].includes(path) ||
  isSharePath(path)
);

const isTrashieContainerPublicPath = (path) => (
  [].includes(path)
);

const isTrashieContainerPublicCenteredPath = (path) => (
  [
    ROUTE_LOGIN,
    ROUTE_SIGNUP,
  ].includes(path)
);

const isTrashieContainerPath = (path) => (
  !isSharePath(path) && (
    [
      ROUTE_LOGOUT,
      ROUTE_SETTINGS,
      ROUTE_ADDRESSES,
      ROUTE_DASHBOARD,
      ROUTE_DASHBOARD_REWARDS,
      ROUTE_PROFILE,
      ROUTE_WALLET,
      ROUTE_TAKE_BACK_BAGS,
      ROUTE_TAKE_BACK_BAGS_DETAILS,
      ROUTE_MY_ACCOUNT,
      ROUTE_WEB_NOTIFICATIONS_INBOX,
      ROUTE_WEB_NOTIFICATIONS_INBOX_ACCOUNT,
      ROUTE_REWARDS,
      ROUTE_TRANSACTIONS,
      ROUTE_OFFERS,
      ROUTE_GIFT_CARDS,
      ROUTE_MEMBERSHIP_ADDRESSES,
    ].includes(path) ||
    path.match(ROUTE_REWARD) ||
    path.match(ROUTE_REWARDS) ||
    path.match(ROUTE_DEALS) ||
    path.match(ROUTE_GIFT_CARDS) ||
    path.match(ROUTE_REWARDS_OLD) ||
    path.match(ROUTE_REWARDS_V2) ||
    path.match(ROUTE_GIFT_CARDS_V2) ||
    path.match(ROUTE_OFFERS_V2) ||
    path.match(ROUTE_MEMBERSHIP)
  )
);

const isTrashieMembershipPath = (path) => (
  path.match(ROUTE_MEMBERSHIP)
);

function getSearchParam(query, searchParam) {
  if (![
    TYPE_SEARCH_PARAM,
    EMAIL_SEARCH_PARAM,
    PROMO_ID_PARAM,
    WF_RETURN_URL_SEARCH_PARAM,
    CATEGORY_SEARCH_PARAM,
    SORT_SEARCH_PARAM,
    TAB_SEARCH_PARAM,
    FILTER_SEARCH_PARAMS.TYPE,
    FILTER_SEARCH_PARAMS.MIN_VALUE,
    FILTER_SEARCH_PARAMS.MAX_VALUE,
    FILTER_SEARCH_PARAMS.OTHER,
    REGISTER_CODE_PARAM,
    REGISTER_SIGN_PARAM,
    REGISTER_SIGNED_AT_PARAM,
    REGISTER_DATA_PARAM,
    REGISTER_FROM_CHECKOUT_PARAM,
    SUBSCRIPTION_FROM_CHECKOUT_PARAM,
    EMBED_LOGIN_BACKGROUND_SEARCH_PARAM,
    MEMBERSHIP_CONFIRM_PARAM,
    STRIPE_SETUP_INTENT_CLIENT_SECRET_PARAM,
    STRIPE_CHECKOUT_SESSION_ID_PARAM,
  ].includes(searchParam)) {
    return '';
  }

  return query.has(searchParam) ? decodeURIComponent(query.get(searchParam)) : '';
}

const isFooterPath = (path) => {
  const routes = [
    ROUTE_REWARDS_V2,
    ROUTE_GIFT_CARDS_V2,
    ROUTE_DASHBOARD,
    ROUTE_DASHBOARD_REWARDS,
    ROUTE_TAKE_BACK_BAGS,
    ROUTE_WALLET,
    ROUTE_MY_ACCOUNT,
    ROUTE_MEMBERSHIP,
  ];

  return routes.some(route => path === route);
};

const isFooterExcludedPath = (path) => {
  const routes = [
    ROUTE_MEMBERSHIP_ADDRESSES,
  ];

  return routes.some(route => path === route) || isSharePath(path);
};

const matchCurrentPath = route => matchPath(window.location.pathname, {
  path: route,
  exact: true,
});

const getRouteData = ({
  route = '',
  routeData = ROUTES_TREE,
  matchRoute = '',
  returnParent = false,
}) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const [childrenRoute, childrenData] of Object.entries(routeData.children)) {
    if (
      (matchRoute && matchRoute === childrenRoute) ||
      (!matchRoute && matchCurrentPath(childrenRoute))
    ) {
      return returnParent ? ({
        route,
        data: routeData,
      }) : ({
        route: childrenRoute,
        data: childrenData,
      });
    }

    if (childrenData.children && Object.keys(childrenData.children).length) {
      const returnRoute = getRouteData({
        route: childrenRoute,
        routeData: childrenData,
        matchRoute,
        returnParent,
      });

      if (returnRoute.route) {
        return returnRoute;
      }
    }
  }

  return {};
};

const getCurrentRouteParentRoute = () => (
  getRouteData({ returnParent: true }).route ?? ''
);

const getCurrentRouteTitle = (includeIcon = false) => {
  const { title = '', icon } = getRouteData({}).data ?? {};

  if (includeIcon && icon) {
    return (
      <>
        <img src={icon} alt="route icon" />
        {title}
      </>
    );
  }

  return title;
};

const getRouteTitle = (matchRoute) => {
  const { title = '' } = getRouteData({ matchRoute }).data ?? {};

  return title;
};

const checkRouteWithCloseButton = () => {
  const { withCloseButton = false } = getRouteData({}).data ?? {};

  return Boolean(withCloseButton);
};

const getCurrentRouteHeaderBackground = () => {
  const { headerBackground = '' } = getRouteData({}).data ?? {};
  return headerBackground;
};

const getNavigationItems = (rewardsV2 = false, activeSubscription = false) => [
  (rewardsV2 ? {
    label: getRouteTitle(ROUTE_REWARDS_V2),
    icon: WandSparklesSvg,
    route: ROUTE_REWARDS_V2,
  } : {
    label: getRouteTitle(ROUTE_DASHBOARD),
    icon: WandSparklesSvg,
    route: ROUTE_DASHBOARD,
  }),
  {
    label: getRouteTitle(ROUTE_DASHBOARD_REWARDS),
    icon: SparklesSvg,
    route: ROUTE_DASHBOARD_REWARDS,
  },
  (activeSubscription ? {
    label: 'Unlimited',
    icon: MembershipSvg,
    route: ROUTE_MEMBERSHIP,
  } : {
    label: getRouteTitle(ROUTE_TAKE_BACK_BAGS),
    icon: RecycleSvg,
    route: ROUTE_TAKE_BACK_BAGS,
  }),
  {
    label: getRouteTitle(ROUTE_WALLET),
    icon: WalletSvg,
    route: ROUTE_WALLET,
  },
  {
    label: getRouteTitle(ROUTE_MY_ACCOUNT),
    icon: UserCircleSvg,
    route: ROUTE_MY_ACCOUNT,
  },
];

const REWARDS_V2_REDIRECT_ROUTES = [
  {
    paths: [
      ROUTE_DEAL_STORE_REWARD_ID,
    ],
    redirectPath: ROUTE_REWARDS_V2_STORE_REWARD_ID,
  },
  {
    paths: [
      ROUTE_DEAL_STORE_ID,
    ],
    redirectPath: ROUTE_REWARDS_V2_STORE_ID,
  },
  {
    paths: [
      ROUTE_DEALS,
    ],
    redirectPath: ROUTE_REWARDS_V2_LIST,
  },
  {
    paths: [
      ROUTE_DASHBOARD,
      ROUTE_HOME,
    ],
    redirectPath: ROUTE_REWARDS_V2,
  },
  {
    paths: [
      ROUTE_OFFERS,
    ],
    redirectPath: ROUTE_OFFERS_V2,
  },
];

const getRewardsV2RedirectPath = ({
  pathname,
  search,
  hash,
}) => {
  const rewardsV2Path = REWARDS_V2_REDIRECT_ROUTES.reduce((result, { paths, redirectPath }) => {
    if (result) {
      return result;
    }

    const matchedPathInfo = paths
      .map(path => matchCurrentPath(path))
      .find(match => match);

    if (!matchedPathInfo) {
      return '';
    }

    const { params } = matchedPathInfo;

    return Object.keys(params).reduce(
      (path, param) => path.replace(`:${param}`, params[param]),
      redirectPath,
    );
  }, '');

  return rewardsV2Path && rewardsV2Path !== pathname
    ? `${rewardsV2Path}${search && search}${hash}`
    : '';
};

export {
  isLoginPath,
  isSignupPath,
  isTrackedPath,
  isRedeemPath,
  isContainerPath,
  isTrashieContainerPublicPath,
  isTrashieContainerPublicCenteredPath,
  isTrashieContainerPath,
  isTrashieMembershipPath,
  getSearchParam,
  isFooterPath,
  matchCurrentPath,
  getRouteData,
  getCurrentRouteTitle,
  getCurrentRouteParentRoute,
  getNavigationItems,
  getRewardsV2RedirectPath,
  checkRouteWithCloseButton,
  getCurrentRouteHeaderBackground,
  isFooterExcludedPath,
  isSharePath,
};
